var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticStyle: { padding: "0px !important", margin: "0px" },
      attrs: { wrap: "" }
    },
    [
      _c(
        "v-layout",
        {
          staticStyle: { "background-color": "none !important" },
          attrs: { row: "", wrap: "" }
        },
        [
          _c(
            "v-flex",
            {
              staticClass: "setBgHeaderRegis widthfull",
              style: { background: _vm.backgroundText },
              attrs: { xs12: "" }
            },
            [
              _c(
                "v-layout",
                {
                  staticStyle: { height: "30px" },
                  attrs: {
                    "align-center": "",
                    "justify-center": "",
                    row: "",
                    wrap: ""
                  }
                },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            "align-center": "",
                            "justify-center": "",
                            row: "",
                            wrap: ""
                          }
                        },
                        [
                          _c(
                            "h3",
                            {
                              staticClass: "centerDiv mt-1",
                              staticStyle: { color: "white" }
                            },
                            [_vm._v("แชทกับเรา")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              staticClass: "setHeightChatBoxRegis",
              staticStyle: { height: "100vh" },
              attrs: { xs12: "" }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "white !important",
                    height: "100vh"
                  }
                },
                [
                  _c(
                    "v-layout",
                    {
                      staticStyle: {
                        "padding-left": "16px",
                        "padding-right": "16px",
                        "padding-top": "10px",
                        "padding-bottom": "10px"
                      },
                      attrs: {
                        row: "",
                        wrap: "",
                        "align-center": "",
                        "justify-start": ""
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "", icon: "", color: "primary" },
                          on: { click: _vm.backPage }
                        },
                        [_c("v-icon", [_vm._v("arrow_back_ios")])],
                        1
                      ),
                      _vm._v(" "),
                      _c("h4", [_vm._v("ข้อมูลเกี่ยวกับการสนทนา")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    {
                      staticStyle: {
                        "padding-left": "16px",
                        "padding-right": "16px",
                        "padding-bottom": "10px"
                      },
                      attrs: {
                        column: "",
                        wrap: "",
                        "align-center": "",
                        "justify-start": ""
                      }
                    },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticStyle: { width: "100% !important" },
                          model: {
                            value: _vm.valid,
                            callback: function($$v) {
                              _vm.valid = $$v
                            },
                            expression: "valid"
                          }
                        },
                        [
                          _c("v-text-field", {
                            style:
                              "width: 100% !important; color: " +
                              _vm.backgroundText +
                              " !important;",
                            attrs: {
                              label: "เลขทิคเก็ต (Ticket Code)",
                              rules: _vm.ticketcodeRules,
                              "single-line": "",
                              solo: ""
                            },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.login()
                              }
                            },
                            model: {
                              value: _vm.con_code,
                              callback: function($$v) {
                                _vm.con_code = $$v
                              },
                              expression: "con_code"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-text-field", {
                            style:
                              "width: 100% !important; color: " +
                              _vm.backgroundText +
                              " !important;",
                            attrs: {
                              label: "อีเมล (E-mail)",
                              rules: _vm.emailRules,
                              "single-line": "",
                              solo: "",
                              required: ""
                            },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.login()
                              }
                            },
                            model: {
                              value: _vm.email,
                              callback: function($$v) {
                                _vm.email = $$v
                              },
                              expression: "email"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            {
                              attrs: {
                                row: "",
                                wrap: "",
                                "align-center": "",
                                "justify-center": ""
                              }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  style:
                                    "background-color: " +
                                    _vm.backgroundText +
                                    " !important; width: 100%; border-radius: 7px;",
                                  attrs: {
                                    dark: "",
                                    loading: _vm.loading,
                                    disabled: !_vm.valid
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.login()
                                    }
                                  }
                                },
                                [_vm._v("เริ่มการแชท")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4646512f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4646512f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Continuechat.vue
// module id = null
// module chunks = 